import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=4a946a82&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=4a946a82&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/orderInfo.less?vue&type=style&index=1&id=4a946a82&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a946a82",
  null
  
)

export default component.exports